import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import { SIZES } from '../constants';

import styles from './TextInputContainer.scss';

type TextInputContainerProps = {
    paddingTop?: typeof SIZES.none | typeof SIZES.animatedPlaceholder;
    usePaddingLeft?: boolean;
};

export const TextInputContainer: FunctionComponent<TextInputContainerProps> = ({
    children,
    paddingTop,
    usePaddingLeft,
}) => {
    const className = classnames(styles.textInputWrapper, {
        [styles.animatedPlaceholderPadding]: paddingTop === SIZES.animatedPlaceholder,
        [styles.usePaddingLeft]: usePaddingLeft,
    });

    return <div className={className}>{children}</div>;
};
